import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, View } from "react-native";

import DependencyAvatar from "./DependencyAvatar";
import DependencyDetail from "./DependencyDetail";

export default class DependencyAvatarWithDetail extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["f", "m", ""]).isRequired,
  };

  render() {
    const { cardNumber, fullName, gender } = this.props;

    return (
      <View style={styles.container}>
        <DependencyAvatar cardNumber={cardNumber} gender={gender} />
        <View style={styles.detailContainer}>
          <DependencyDetail cardNumber={cardNumber} fullName={fullName} />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flexDirection: "row",
    flexGrow: 1,
    padding: 10,
    paddingEnd: 100,
    width: 0,
  },
  detailContainer: {
    marginStart: 15,
  },
});
